import theme from "../styles/theme";

/**
 * Gets a color from the theme by searching through all nested color objects
 * @param colorName - The name of the color to find (e.g., 'red', 'primary.red')
 * @returns The color value if found, undefined otherwise
 */
export const getColor = (colorName?: string): string | undefined => {
  // Return undefined if colorName is not provided
  if (!colorName) {
    return undefined;
  }

  // If using dot notation (e.g., 'primary.red')
  if (colorName.includes(".")) {
    const [category, name] = colorName.split(".");
    return theme.colors[category]?.[name];
  }

  // Otherwise search through all color categories
  for (const category in theme.colors) {
    const colorCategory = theme.colors[category];

    // Check if the color exists directly in this category
    if (colorName in colorCategory) {
      return colorCategory[colorName];
    }
  }

  return undefined;
};

export default getColor;
